import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'sabis-ngx-downarrow-icon',
    template: `
    <svg [attr.class]="scClass" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.15 9.61"><defs></defs><title>{{scTooltipLabel}}</title><g id="Layer_2" data-name="Layer 2"><g id="Layer"><path class="cls-1" d="M0,.57A.5.5,0,0,1,.85.22L9.11,8.4,17.3.15a.5.5,0,1,1,.71.7L9.46,9.46a.5.5,0,0,1-.71,0L.15.93A.5.5,0,0,1,0,.57Z"/></g></g></svg>
`
})
export class SabisDownArrowIconComponent implements OnInit {
  @Input() scClass: string = '';
  @Input() scTooltipLabel: string = '';

  constructor() { }

  ngOnInit() {
  }
}
